import axios from '../../../axios';
import { IFile } from '../../../types';
import IRightToRepresent from '../types/IRightToRepresent';
import UploadedFilesType from '../types/IUploadFilesType';

const bulkSubmissionsUrl = '/candidatesearch/api/candidate/bulk-submissions';

export const uploadCvForSubmissions = (rowId: number, fileId: string, file: IFile) =>
  axios.post(`${bulkSubmissionsUrl}/upload-cv?rowId=${rowId}&fileId=${fileId}`, file);

export const deleteCvForSubmissions = (rowId: number, fileId: string) =>
  axios.delete(`${bulkSubmissionsUrl}/upload-cv?rowId=${rowId}&fileId=${fileId}`);

export const getProcessedExcelRecordsByFileId = (fileId: string) =>
  axios.get(`${bulkSubmissionsUrl}/read-excel-records/${fileId}`);

export const uploadRtrForSubmissions = (rowId: number, fileId: string, rtr: IRightToRepresent) =>
  axios.post(`${bulkSubmissionsUrl}/upload-rtr?rowId=${rowId}&fileId=${fileId}`, rtr);

export const deleteRtrForSubmissions = (rowId: number, fileId: string) =>
  axios.delete(`${bulkSubmissionsUrl}/upload-rtr?rowId=${rowId}&fileId=${fileId}`);

export const parseUploadedCv = (payload: UploadedFilesType) =>
  axios.post('/candidatesearch/api/parse-cv', payload);
